import sheetConfig from './sheetConfig';

import {
    ErrorSheetOpenAction,
    SheetActionTypes,
    SheetCloseAction,
    SheetCloseTransitionCompleteAction,
    SheetOpenAction,
    SheetUpdateActiveSnapPointAction,
} from './sheetActionTypes';
import { SheetCloseOptions, SheetId, SheetOpenOptions } from './sheetTypes';

export const openSheet = (sheetId: SheetId, instanceId?: string, options?: SheetOpenOptions): SheetOpenAction => ({
    type: SheetActionTypes.SHEET_OPEN,
    sheetId,
    instanceId,
    config: sheetConfig[sheetId],
    options,
});

export const openErrorSheet = (activeErrorNoticeId: string, data: object | undefined): ErrorSheetOpenAction => {
    const sheetId = SheetId.Error;
    return {
        type: SheetActionTypes.SHEET_OPEN,
        sheetId,
        config: sheetConfig[sheetId],
        activeErrorNoticeId,
        data,
    };
};

export const closeSheet = (sheetId: SheetId, instanceId?: string, options?: SheetCloseOptions): SheetCloseAction => ({
    type: SheetActionTypes.SHEET_CLOSE,
    sheetId,
    instanceId,
    options,
});

export const completeSheetCloseTransition = (sheetKey: string): SheetCloseTransitionCompleteAction => ({
    type: SheetActionTypes.SHEET_CLOSE_TRANSITION_DID_COMPLETE,
    sheetKey,
});

export const updateSheetActiveSnapPoint = (
    activeSnapPoint: number,
    sheetId: SheetId,
    instanceId?: string,
): SheetUpdateActiveSnapPointAction => ({
    type: SheetActionTypes.SHEET_UPDATE_ACTIVE_SNAP_POINT,
    sheetId,
    instanceId,
    activeSnapPoint,
});
